Greenmile.Survey = Greenmile.Survey || {};
Greenmile.Survey.Templates = Greenmile.Survey.Templates || {};
Greenmile.Survey.Templates.SurveyCreateQuestionTemplate = function () {
  return new Monet.UI.LayoutGenerator({
    'items': [
      {
        'attributes': {
          'id': 'SurveyTemplateContainer',
        },
        'items': [
          {
            'attributes': {
              'class': 'sidebar',
            },
          },
          {
            'items': [
              {
                'items': [
                  {
                    'tag': 'input',
                    'attributes': {
                      'type': 'button',
                      'class': 'btn i18nResource btn-secondary',
                      'value': Monet.I18n.getResourcesByKey('Survey.filter.btn.cancelButton'),
                      'id': 'LinkFormCancelButton',
                    },
                  },
                  {
                    'tag': 'input',
                    'attributes': {
                      'type': 'button',
                      'class': 'btn i18nResource',
                      'value': Monet.I18n.getResourcesByKey('Survey.filter.btn.saveButton'),
                      'id': 'LinkFormSaveButton',
                      'style': 'float:right;',
                    },
                  },
                ],
                'attributes': {
                  'class': 'buttonGroup standard-form-buttons',
                },
              },
              {
                'attributes': {
                  'class': 'monetInlineAlerContainer',
                },
              },
              {
                'attributes': {
                  'class': 'questionContent',
                },
              },
            ],
            'attributes': {
              'class': 'formContent',
            },
          },
        ],
      },
    ],
  }).render();
};
